import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { getResetCommandName } from '../../../common/constants/resetButtons';
import ConfirmationDialog from '../../../common/components/Form/ConfirmationDialog';
import { Snackbar } from '../../../common/components/Snackbar/Snackbar';

function ResetDialog({
  resetErrorSnackbar,
  resetSuccessSnackbar,
  c_uuid: chargerUuid,
  resetError,
  resetCommand,
  openResetDialogFlag,
  config,
  toggleSnackbar,
  closeResetDialog,
  resetCharger,
}) {
  const handleCloseSnackBar = () => {
    toggleSnackbar(false);
  };

  useEffect(() => {
    handleCloseSnackBar();
  }, []);

  const submitResetDialog = (chargerUuid) => {
    resetCharger(chargerUuid, resetCommand);
    closeResetDialog();
  };

  const resetCommandName = getResetCommandName(resetCommand, config);
  const confirmationText = `Are you sure you want to perform ${resetCommandName}?`;
  const resetSuccessMessage = `${resetCommandName} command was successfully sent to the ${chargerUuid} charger.`;

  return (
    <span>
      <Snackbar open={resetErrorSnackbar} message={resetError} onClose={handleCloseSnackBar} />
      <Snackbar open={resetSuccessSnackbar} message={resetSuccessMessage} onClose={handleCloseSnackBar} />
      <ConfirmationDialog
        onSubmit={() => submitResetDialog(chargerUuid)}
        onCancel={closeResetDialog}
        submitLabel="Reset"
        cancelLabel="Cancel"
        open={openResetDialogFlag}
        bodyText={confirmationText}
      />
    </span>
  );
}

ResetDialog.propTypes = {
  c_uuid: PropTypes.string,
  openResetDialogFlag: PropTypes.bool,
  resetCharger: PropTypes.func,
  resetCommand: PropTypes.string,
  resetError: PropTypes.string,
  resetErrorSnackbar: PropTypes.bool,
  resetSuccessSnackbar: PropTypes.bool,
};

export default ResetDialog;
